import React from 'react';
import { useTranslation } from '../context/TranslationContext';

/**
 * Composant de sélection réutilisable pour les listes World Anvil
 */
export default function WASelectList({ 
  label, 
  items = [], 
  selectedValue, 
  onSelect, 
  loading = false, 
  error = null, 
  disabled = false,
  placeholder = null 
}) {
  const { t } = useTranslation();

  const defaultPlaceholder = placeholder || t('CONFIG', 'SELECT_OPTION', 'Select option');

  const handleChange = (e) => {
    const selectedId = e.target.value;
    if (selectedId && selectedId !== '') {
      const selectedItem = items.find(item => item.id === selectedId);
      if (selectedItem && onSelect) {
        onSelect(selectedItem);
      }
    }
  };

  return (
    <div>
      {label && (
        <label className="wa-label">
          {label} :
        </label>
      )}
      <select 
        className="wa-select"
        value={selectedValue?.id || ''}
        onChange={handleChange}
        disabled={disabled || loading}
      >
        <option value="">
          {loading 
            ? t('CONFIG', 'LOADING', 'Loading...') 
            : error 
              ? t('CONFIG', 'ERROR_LOADING', 'Error loading')
              : defaultPlaceholder
          }
        </option>
        {items.map(item => (
          <option key={item.id} value={item.id}>
            {item.title}
          </option>
        ))}
      </select>
      {error && (
        <div className="text-red-600 text-sm mt-1">
          {t('CONFIG', 'ERROR', 'Error')}: {error}
        </div>
      )}
    </div>
  );
}
